var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-layout form-layout-2"},[(this.isAngeloni)?_c('operational-integration-angeloni'):(this.isDuasRodas)?_c('operational-integration-duas-rodas'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }